<template>
  <full-screen-layout>
    <div slot="mainContent">
      <exporter-central class="mt-5" />
    </div>
  </full-screen-layout>
</template>

<script>
import ExporterCentral from "@/components/exporter/ExporterCentral.vue";
import FullScreenLayout from "@/layouts/FullScreenLayout.vue";
export default {
  name: "ExportPublish",
  components: {FullScreenLayout, ExporterCentral},

}
</script>